var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNexusShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 200,
    viewBox: "0 0 170 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2886_4526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.975 43.44V82.63L100.215 101.39L100.165 101.44V24.63L100.185 24.65L100.215 24.68L118.975 43.44Z",
    fill: "url(#paint0_linear_2886_4526)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8346 142.01V65.2L69.8147 65.22L51.0146 84.01V123.2L69.8346 142.01Z",
    fill: "url(#paint1_linear_2886_4526)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.595 126.01V65.2H69.835L94.405 40.63V101.45H100.165L75.595 126.01Z",
    fill: "#9ECC3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9947 199.77L0.264648 156.43V89.66L6.61465 83.32L0.774648 77.48V0H169.225V77.48L163.385 83.32L169.735 89.66V156.43L85.0046 199.77H84.9947ZM6.02465 152.91L85.0046 193.3L163.985 152.91V92.05H146.525L163.475 75.1V5.76H6.53465V75.1H22.9946L6.02465 92.05V152.91Z",
    fill: "url(#paint2_linear_2886_4526)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2886_4526",
    x1: 109.565,
    y1: 101.44,
    x2: 109.565,
    y2: 24.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#27A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#47AD3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#62B63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#78BE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#89C43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95C83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9CCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECC3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2886_4526",
    x1: 60.4246,
    y1: 142.01,
    x2: 60.4246,
    y2: 65.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ECC3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9CCB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#95C83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#89C43C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#78BE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#62B63E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#47AD3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#27A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2886_4526",
    x1: 84.9947,
    y1: 198.66,
    x2: 84.9947,
    y2: 0.399989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0D9843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#31A541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6BBA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECC3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2886_4526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169.47,
    height: 199.77,
    fill: "white",
    transform: "translate(0.264648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNexusShield);
export default __webpack_public_path__ + "static/media/ic_nexus_shield.70bf5231c2bb732871e02ec3217eb6a1.svg";
export { ForwardRef as ReactComponent };